import React, { useState } from "react";
import { FaTwitter, FaLinkedin, FaMedium, FaGithub, FaBars, FaTimes } from "react-icons/fa";
import { HiDocumentText, HiDownload, HiShieldCheck } from "react-icons/hi";
import { Link } from "react-router-dom";
import DarkModeToggle from "./DarkModeToggle";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="fixed z-50 w-full bg-white dark:bg-gray-900 top-0 flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg shadow-lg transition-colors duration-300">
      <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
        <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
          <Link
            className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase text-gray-800 dark:text-white hover:opacity-75 transition-opacity"
            to="/"
            onClick={closeMobileMenu}
          >
            Tushar Singh
          </Link>
          <button
            className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent lg:hidden outline-none focus:outline-none text-gray-800 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle navigation menu"
            aria-expanded={mobileMenuOpen}
          >
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
        <div
          className={`lg:flex flex-grow items-center ${
            mobileMenuOpen ? 'flex' : 'hidden'
          } w-full lg:w-auto transition-all duration-300 ease-in-out`}
          id="navbar-menu"
        >
          <ul className="flex flex-col lg:flex-row list-none lg:ml-auto items-center w-full lg:w-auto">
            <li className="nav-item w-full lg:w-auto">
              <Link
                to="https://x.com/tusharsingh1991"
                className="px-3 py-3 lg:py-2 flex items-center justify-center lg:justify-start text-xs uppercase font-bold text-gray-800 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors min-h-[44px]"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                aria-label="Twitter"
              >
                <FaTwitter className="text-lg leading-lg text-gray-500 dark:text-gray-400" />
              </Link>
            </li>
            <li className="nav-item w-full lg:w-auto">
              <Link
                to="https://www.linkedin.com/in/tusharsingh1991/"
                className="px-3 py-3 lg:py-2 flex items-center justify-center lg:justify-start text-xs uppercase font-bold text-gray-800 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors min-h-[44px]"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                aria-label="LinkedIn"
              >
                <FaLinkedin className="text-lg leading-lg text-gray-500 dark:text-gray-400" />
              </Link>
            </li>

            <li className="nav-item w-full lg:w-auto">
              <Link
                to="https://medium.com/@tusharsingh1991"
                className="px-3 py-3 lg:py-2 flex items-center justify-center lg:justify-start text-xs uppercase font-bold text-gray-800 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors min-h-[44px]"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                aria-label="Medium"
              >
                <FaMedium className="text-lg leading-lg text-gray-500 dark:text-gray-400" />
              </Link>
            </li>

            <li className="nav-item w-full lg:w-auto">
              <Link
                to="https://github.com/tusharsingh1991"
                className="px-3 py-3 lg:py-2 flex items-center justify-center lg:justify-start text-xs uppercase font-bold text-gray-800 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors min-h-[44px]"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                aria-label="GitHub"
              >
                <FaGithub className="text-lg leading-lg text-gray-500 dark:text-gray-400" />
              </Link>
            </li>
            <li className="nav-item w-full lg:w-auto">
              <Link
                target="_blank"
                className="px-3 py-3 lg:py-2 flex items-center justify-center lg:justify-start text-xs uppercase text-gray-800 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors min-h-[44px]"
                to={`/assets/tusharsingh.pdf`}
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
              >
                <HiDocumentText className="text-lg leading-lg text-gray-500 dark:text-gray-400" />
                <span className="ml-2">Resume</span>
              </Link>
            </li>
            <li className="nav-item w-full lg:w-auto">
              <Link
                className="download-button px-3 py-3 lg:py-2 flex items-center justify-center lg:justify-start text-xs uppercase text-gray-800 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors min-h-[44px]"
                to={"/resources"}
                onClick={closeMobileMenu}
              >
                <HiDownload className="text-lg leading-lg text-gray-500 dark:text-gray-400" />
                <span className="ml-2">Resources</span>
              </Link>
            </li>
            <li className="nav-item w-full lg:w-auto">
              <Link
                to={"/privacy-policy"}
                className="download-button px-3 py-3 lg:py-2 flex items-center justify-center lg:justify-start text-xs uppercase text-gray-800 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors min-h-[44px]"
                onClick={closeMobileMenu}
              >
                <HiShieldCheck className="text-lg leading-lg text-gray-500 dark:text-gray-400" />
                <span className="ml-2">Privacy Policy</span>
              </Link>
            </li>
            <li className="nav-item ml-0 lg:ml-2 w-full lg:w-auto py-2 lg:py-0 flex justify-center">
              <DarkModeToggle />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;